import { render, staticRenderFns } from "./ProductInfolist.vue?vue&type=template&id=1f35eb46&"
import script from "./ProductInfolist.vue?vue&type=script&lang=js&"
export * from "./ProductInfolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports